



























import { Component, Vue } from "vue-property-decorator";
import CustomChart from "@/components/CustomChart.vue";
import VCheckButton from "@/components/VCheckButton.vue";

@Component({
  components: {
    CustomChart,
    VCheckButton,
  },
})
export default class Icons extends Vue {
  chart = {
    stacked: false,
    labels: ["Gennaio 2020", "Febbraio 2020", "Marzo 2020", "Aprile 2020"],
    items: [
      {
        label: "AMERICAN EXPRESS",
        data: [18000, 19000, 22000, 14000],
      },
      {
        label: "UNIPOLSAI ASSICURAZIONI",
        data: [28000, 31000, 12000, 18500],
      },
      {
        label: "COMPASS PRESTITI",
        data: [14000, 21000, 11000, 30500],
      },
    ],
  };
}
